<template>
	<!-- создать доступ для внешних инструментов -->
	<div ng-if="overlayController" class="windowOverlay" id="startDeletion" ng-controller="overlayController">
		<div class="darkener clickable" clickable="closeOverlay()"></div>
		<div ng-include="" src="overlayConfig['inWindowPopupTemplate']" dynamic-height="true" dynamic-max-height="801">
			<div class="inWindowPopup" ng-class="{warning: overlayConfig['isAWarning']}">
				<div class="inWindowPopupHeader">
					<h4 translate="" options="DeleteAccount" ng-if="overlayConfig['inWindowPopupTitle'] != ''"><span>Удалить персонажа</span></h4>
					<h4 ng-if="overlayConfig['inWindowPopupTitleText'] != ''"></h4>
					<a class="closeOverlay clickable" clickable="closeOverlay()" translate=""><span>Закрыть</span></a>
				</div>
				<div class="inWindowPopupContent">
					<div ng-include="" src="overlayConfig['inWindowPopupContentTemplate']">
						<div>
							<div translate=""><span>Здесь ты можешь удалить своего персонажа. </span><br><span>Удаление занимает три дня. В течение этого времени ты можешь в любое время прервать процесс удаления, нажав на кнопку "Отменить удаление". </span><br><span>Остаток приобретенного золота удаляемого персонажа будет автоматически переведен в Лобби. Оттуда ты можешь забрать его в один из своих активных игровых миров.</span><br><span>Пока идет удаление героя возможность пользоваться аукционом и пунктом обмена отключена.</span></div>
							<div>
								<div class="buttonFooter">
									<button clickable="deleteAccount();" class="clickable">
										<div class="content">
											<span ng-transclude="" class="innerText">
												<span translate=""><span>Удалить</span></span>
											</span>
											<!-- ngIf: price > 0 || forceGoldUsage -->
											<!-- ngIf: price == -1 && !forceGoldUsage -->
											<div class="animationOverlay"></div>
											<i class="checkmark action_check_small_flat_white"></i>
											<i class="checkmark action_check_small_flat_black"></i>
											<i class="checkmark action_check_small_flat_red"></i>
										</div>
									</button>
									<button class="cancel clickable" clickable="closeOverlay();">
										<div class="content">
											<span ng-transclude="" class="innerText">
												<span translate=""><span>Отмена</span></span>
											</span>
											<!-- ngIf: price > 0 || forceGoldUsage -->
											<!-- ngIf: price == -1 && !forceGoldUsage -->
											<div class="animationOverlay"></div>
											<i class="checkmark action_check_small_flat_white"></i>
											<i class="checkmark action_check_small_flat_black"></i>
											<i class="checkmark action_check_small_flat_red"></i>
										</div>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	mounted(){},
	components: {},
}
</script>